import { useState, useEffect, useContext } from "react";
import placeholder from "../inc/placeholder.jpg";
import { SiteContext } from "../contexts/SiteContext";
import { ViewContext } from "../contexts/ViewContext";
import { Link } from "react-router-dom";
import {
	Paper,
	Typography,
	Grid,
	Card,
	CardMedia,
	CardContent,
	CardActionArea,
	makeStyles,
	Fade,
	Tooltip,
	Hidden,
	IconButton,
} from "@material-ui/core";
import ViewListIcon from "@material-ui/icons/ViewList";
import ViewGridIcon from "@material-ui/icons/ViewModule";

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: "1rem",
		marginBottom: "1rem",
		marginTop: "1rem",
		position: "relative",
	},
	media: { paddingBottom: "100%" },
	horizCard: {
		marginBottom: "1rem",
	},
	link: {
		color: "black",
		textDecoration: "none",
	},
	horizCardActionArea: {
		display: "flex",
		justifyContent: "start",
	},
	horizMedia: {
		paddingBottom: "12%",
		paddingRight: "12%",
	},
	horizCardContent: {},
}));

//---------------
// MAIN COMPONENT
//---------------

function Themes() {
	const classes = useStyles();
	const [themes, setThemes] = useState();
	const [loading, setLoading] = useState(true);
	const { selectedSite } = useContext(SiteContext);
	const { themesView, setThemesView } = useContext(ViewContext);

	useEffect(() => {
		const fetchData = async () => {
			let url = `${process.env.REACT_APP_API_URL}/themes?sort=name`;
			const res = await fetch(url, { credentials: "include" });
			let allThemes = await res.json();
			if (allThemes.success) {
				// Filter out themes not in selectedSite
				setThemes(
					allThemes.data.filter((theme) => theme.site._id === selectedSite._id)
				);
			} else {
				console.log(allThemes.error);
			}
		};
		fetchData();
		setLoading(false);
	}, []);

	if (loading || !themesView) {
		return "Loading...";
	}

	return (
		<>
			{themes && themes.length > 0 && (
				<Fade in={!loading}>
					<Paper className={classes.paper}>
						<Typography
							style={{ marginBottom: "1rem" }}
							component="h3"
							variant="h6"
							align="center"
						>
							Themes
						</Typography>
						<div
							style={{
								display: "flex",
								justifyContent: "flex-end",
								position: "absolute",
								right: ".5rem",
								top: ".5rem",
							}}
						>
							<Hidden smDown>
								{themesView === "grid" ? (
									<Tooltip
										title="View themes as a list"
										aria-label="View themes as a list"
										placement="top"
									>
										<IconButton
											aria-label="View the themes in a list format"
											onClick={() => setThemesView("list")}
											variant="contained"
										>
											<ViewListIcon />
										</IconButton>
									</Tooltip>
								) : (
									<Tooltip
										title="View themes as a grid"
										aria-label="View themes as a grid"
										placement="top"
									>
										<IconButton
											aria-label="View the themes in a grid format"
											onClick={() => setThemesView("grid")}
											variant="contained"
										>
											<ViewGridIcon />
										</IconButton>
									</Tooltip>
								)}
							</Hidden>
						</div>

						<Hidden smDown>
							{themesView === "list" ? (
								<ThemesList themes={themes} />
							) : (
								<ThemesGrid themes={themes} />
							)}
						</Hidden>

						{/*On mobile devices, only allow displaying the ThemesGrid*/}
						<Hidden mdUp>
							<ThemesGrid themes={themes} />
						</Hidden>
					</Paper>
				</Fade>
			)}
		</>
	);
}

//----------
// GRID VIEW
//----------

function ThemesGrid({ themes }) {
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);

	if (!themes) {
		return "Please pass themes to the ThemesGrid component...";
	}

	return (
		<Grid container spacing={3}>
			{themes.map((theme, index) => {
				return (
					<Grid item key={index} xs={6} sm={4} md={3} lg={3}>
						<Card elevation={0} className={classes.card} aria-label>
							<Link
								className={classes.link}
								to={`/${selectedSite.slug}/themes/${theme.slug}`}
							>
								<CardActionArea>
									<CardMedia
										className={classes.media}
										image={
											theme.featuredImage
												? `${process.env.REACT_APP_FILE_URL}/${theme.featuredImage.thumbnailName}`
												: placeholder
										}
										title={theme.name}
									/>
								</CardActionArea>
							</Link>
						</Card>
					</Grid>
				);
			})}
		</Grid>
	);
}

//----------
// LIST VIEW
//----------
//
function ThemesList({ themes }) {
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);

	if (!themes) {
		return "Please pass themes to the ThemesList component...";
	}

	return (
		<>
			{themes.map((theme, index) => {
				return (
					<Card key={index} className={classes.horizCard}>
						<Link
							className={classes.link}
							to={`/${selectedSite.slug}/themes/${theme.slug}`}
						>
							<CardActionArea className={classes.horizCardActionArea}>
								<CardMedia
									className={classes.horizMedia}
									image={
										theme.featuredImage
											? `${process.env.REACT_APP_FILE_URL}/${theme.featuredImage.thumbnailName}`
											: placeholder
									}
									title={theme.name}
								/>
								<CardContent className={classes.horizCardContent}>
									<Typography variant="h6" component="h4">
										{theme.name}
									</Typography>
								</CardContent>
							</CardActionArea>
						</Link>
					</Card>
				);
			})}
		</>
	);
}

export default Themes;
